import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * Sorting options
 *
 * @generated from protobuf enum dispatch_group.v1.SortDirection
 */
export var SortDirection;
(function (SortDirection) {
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_UNSPECIFIED = 0;
     */
    SortDirection[SortDirection["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_ASC = 1;
     */
    SortDirection[SortDirection["ASC"] = 1] = "ASC";
    /**
     * @generated from protobuf enum value: SORT_DIRECTION_DESC = 2;
     */
    SortDirection[SortDirection["DESC"] = 2] = "DESC";
})(SortDirection || (SortDirection = {}));
// @generated message type with reflection information, may provide speed optimized methods
class Timestamps$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.Timestamps", [
            { no: 1, name: "created_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "updated_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 3, name: "deleted_at", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.createdAt = 0n;
        message.updatedAt = 0n;
        message.deletedAt = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint64 created_at */ 1:
                    message.createdAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 updated_at */ 2:
                    message.updatedAt = reader.uint64().toBigInt();
                    break;
                case /* uint64 deleted_at */ 3:
                    message.deletedAt = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* uint64 created_at = 1; */
        if (message.createdAt !== 0n)
            writer.tag(1, WireType.Varint).uint64(message.createdAt);
        /* uint64 updated_at = 2; */
        if (message.updatedAt !== 0n)
            writer.tag(2, WireType.Varint).uint64(message.updatedAt);
        /* uint64 deleted_at = 3; */
        if (message.deletedAt !== 0n)
            writer.tag(3, WireType.Varint).uint64(message.deletedAt);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.Timestamps
 */
export const Timestamps = new Timestamps$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SortOptions$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.SortOptions", [
            { no: 1, name: "field", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "direction", kind: "enum", T: () => ["dispatch_group.v1.SortDirection", SortDirection, "SORT_DIRECTION_"] }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.field = "";
        message.direction = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string field */ 1:
                    message.field = reader.string();
                    break;
                case /* dispatch_group.v1.SortDirection direction */ 2:
                    message.direction = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string field = 1; */
        if (message.field !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.field);
        /* dispatch_group.v1.SortDirection direction = 2; */
        if (message.direction !== 0)
            writer.tag(2, WireType.Varint).int32(message.direction);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.SortOptions
 */
export const SortOptions = new SortOptions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HydrationOptions$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.HydrationOptions", [
            { no: 1, name: "include_grid_services", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "include_behind_the_meter_services", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "include_delivery_points", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "include_devices", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.includeGridServices = false;
        message.includeBehindTheMeterServices = false;
        message.includeDeliveryPoints = false;
        message.includeDevices = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool include_grid_services */ 1:
                    message.includeGridServices = reader.bool();
                    break;
                case /* bool include_behind_the_meter_services */ 2:
                    message.includeBehindTheMeterServices = reader.bool();
                    break;
                case /* bool include_delivery_points */ 3:
                    message.includeDeliveryPoints = reader.bool();
                    break;
                case /* bool include_devices */ 4:
                    message.includeDevices = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bool include_grid_services = 1; */
        if (message.includeGridServices !== false)
            writer.tag(1, WireType.Varint).bool(message.includeGridServices);
        /* bool include_behind_the_meter_services = 2; */
        if (message.includeBehindTheMeterServices !== false)
            writer.tag(2, WireType.Varint).bool(message.includeBehindTheMeterServices);
        /* bool include_delivery_points = 3; */
        if (message.includeDeliveryPoints !== false)
            writer.tag(3, WireType.Varint).bool(message.includeDeliveryPoints);
        /* bool include_devices = 4; */
        if (message.includeDevices !== false)
            writer.tag(4, WireType.Varint).bool(message.includeDevices);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.HydrationOptions
 */
export const HydrationOptions = new HydrationOptions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DispatchGroupFilter$Type extends MessageType {
    constructor() {
        super("dispatch_group.v1.DispatchGroupFilter", [
            { no: 1, name: "names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "dispatcher_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "tso_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "include_deleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "created_after", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 6, name: "created_before", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.names = [];
        message.dispatcherIds = [];
        message.tsoIds = [];
        message.includeDeleted = false;
        message.createdAfter = 0n;
        message.createdBefore = 0n;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string names */ 1:
                    message.names.push(reader.string());
                    break;
                case /* repeated string dispatcher_ids */ 2:
                    message.dispatcherIds.push(reader.string());
                    break;
                case /* repeated string tso_ids */ 3:
                    message.tsoIds.push(reader.string());
                    break;
                case /* bool include_deleted */ 4:
                    message.includeDeleted = reader.bool();
                    break;
                case /* uint64 created_after */ 5:
                    message.createdAfter = reader.uint64().toBigInt();
                    break;
                case /* uint64 created_before */ 6:
                    message.createdBefore = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated string names = 1; */
        for (let i = 0; i < message.names.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.names[i]);
        /* repeated string dispatcher_ids = 2; */
        for (let i = 0; i < message.dispatcherIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.dispatcherIds[i]);
        /* repeated string tso_ids = 3; */
        for (let i = 0; i < message.tsoIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.tsoIds[i]);
        /* bool include_deleted = 4; */
        if (message.includeDeleted !== false)
            writer.tag(4, WireType.Varint).bool(message.includeDeleted);
        /* uint64 created_after = 5; */
        if (message.createdAfter !== 0n)
            writer.tag(5, WireType.Varint).uint64(message.createdAfter);
        /* uint64 created_before = 6; */
        if (message.createdBefore !== 0n)
            writer.tag(6, WireType.Varint).uint64(message.createdBefore);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message dispatch_group.v1.DispatchGroupFilter
 */
export const DispatchGroupFilter = new DispatchGroupFilter$Type();
//# sourceMappingURL=common.js.map